export default {"src":"/_next/static/media/good.eeb1058c.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};